import Vue from 'vue'
import get from 'lodash/get'

export default {
  namespaced: true,

  state: {
    messages: {}
  },

  getters: {
    getMessage:
      (state) =>
      (topic = 'general') => {
        return get(state.messages, topic, null)
      }
  },

  mutations: {
    messageAdded(state, { message, topic = 'general' }) {
      Vue.set(state.messages, topic, message)
    },

    messageCleared(state, { topic = 'general' }) {
      Vue.delete(state.messages, topic)
    },

    resetState(state) {
      state.messages = {}
    }
  },

  actions: {
    addFlashMessage({ commit }, { message, topic = 'general' }) {
      commit('messageAdded', { message, topic })

      return message
    },

    clearFlashMessage({ commit }, { topic = 'general' }) {
      commit('messageCleared', { topic })
    },

    clearFlashMessages({ commit }) {
      commit('resetState')
    }
  }
}
